import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
import { createAction } from 'redux-actions';
import { reduxKey } from './constants';
import { ReferralType } from '@wix/da-bi/pkg/constants';
import { pushModal } from '../../Modals/redux/basicActions';
import { verifyLoggedOutAccess } from '../../redux/loggedout/actionCreators';
import { ModalType } from '../../Modals/redux/types';
export const reduxInitialized = createAction(`${reduxKey}.REDUX_INITIALIZED`, ()=>({}));
export const initGiftState = createAction(`${reduxKey}.INIT_GIFT_STATE`, (user)=>({
        user
    }));
export const initGiftStateSuccess = createAction(`${reduxKey}.INIT_GIFT_STATE_SUCCESS`, (user, payload)=>_object_spread({
        user
    }, payload));
export const initGiftStateFailure = createAction(`${reduxKey}.INIT_GIFT_STATE_FAILURE`, (user)=>({
        user
    }));
export const pushGivePointsModal = verifyLoggedOutAccess(ReferralType.GIVE, (username, title)=>pushModal(ModalType.GIVE_POINTS, {
        params: {
            username,
            title
        },
        wrapInModal: false
    }));

//# sourceMappingURL=actions.js.map